export default "__VITE_ASSET__b3e1cafe__"